import Vue from 'vue';
export default {
    namespaced: true,
    state: {
        friends: {}
    },
    getters: {
        friends(state) {
            return state.friends;
        }
    },
    mutations: {
        setValue(state, data) {
            state[data[0]] = data[1];
        },
        removeFriend(state, data) {
            Vue.delete(state.friends, data.id);
        },
        updateFriend(state, data) {
            if (state.friends[data.id])
                state.friends[data.id].online = data.status;
        },
        addFriend(state, data) {
            Vue.set(state.friends, data.id, {
                online: data.online,
                name: data.name,
                id: data.id
            });
        },
    },
    actions: {
        setValue({ commit }, data) {
            commit('setValue', data)
        },
        removeFriend({ commit }, data) {
            commit('removeFriend', data)
        },
        updateFriend({ commit }, data) {
            commit('updateFriend', data)
        },
        addFriend({ commit }, data) {
            commit('addFriend', data)
        }
    }
};